// npm
import React, { Component } from 'react';

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

// react
import { MaterialText } from "components/presentation/material-text";

import { withMessages } from "components/hocs/messages";
import { MESSAGE_IDS } from "constants/message-ids";
import { isValidMessage } from "utils/message-helper";

class IctAnswerForm extends Component {
    state = {};
	
	componentWillUnmount() {
        const { value, onChange } = this.props;
        if (value !== "") {
            onChange("visited");
        }
	}
	
    render() {
        const { classes, messages } = this.props;
        const message = messages[MESSAGE_IDS.EXAM.UPLOAD_EVIDENCE];
        const defaultMessage = "Please upload your evidence";

        return (
            <MaterialText className={classes.text}>
                {isValidMessage(message) ? message : defaultMessage}
            </MaterialText>
        );
    }
}

const styles = ({ palette }) => ({
    text: { color: palette.background.contrastText },
});

IctAnswerForm = withMessages(withStyles(styles)(IctAnswerForm));

export { IctAnswerForm };
